import { AUDIO_SETTINGS_VERSION } from '../../../electron/common/audioTypes';
import type { AudioSettings } from './audioDeviceTypes';

export function defaultAudioSettings(): AudioSettings {
  return {
    version: AUDIO_SETTINGS_VERSION,
    recommendedMicrophone: null,
    confirmedMicrophone: null,
    confirmedSpeaker: null,
    notifyWhenRecommendedAvailable: true,
  };
}
